"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("styled-components");

var Font_config_1 = __importDefault(require("./Font.config"));

var Font = function Font(environment) {
  return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @font-face {\n    font-family: 'Brandon Text';\n    font-display: auto;\n    font-weight: 300;\n    font-style: normal;\n    src: url(", "/fonts/BrandonText-Light.woff2);\n  }\n\n  @font-face {\n    font-family: 'Brandon Text';\n    font-display: auto;\n    font-weight: 400;\n    font-style: normal;\n    src: url(", "/fonts/BrandonText-Regular.woff2);\n  }\n\n  @font-face {\n    font-family: 'Brandon Text';\n    font-display: auto;\n    font-weight: 500;\n    font-style: normal;\n    src: url(", "/fonts/BrandonText-Medium.otf);\n  }\n\n  @font-face {\n    font-family: 'Brandon Text';\n    font-display: auto;\n    font-weight: 700;\n    font-style: normal;\n    src: url(", "/fonts/BrandonText-Bold.woff2);\n  }\n"], ["\n  @font-face {\n    font-family: 'Brandon Text';\n    font-display: auto;\n    font-weight: 300;\n    font-style: normal;\n    src: url(", "/fonts/BrandonText-Light.woff2);\n  }\n\n  @font-face {\n    font-family: 'Brandon Text';\n    font-display: auto;\n    font-weight: 400;\n    font-style: normal;\n    src: url(", "/fonts/BrandonText-Regular.woff2);\n  }\n\n  @font-face {\n    font-family: 'Brandon Text';\n    font-display: auto;\n    font-weight: 500;\n    font-style: normal;\n    src: url(", "/fonts/BrandonText-Medium.otf);\n  }\n\n  @font-face {\n    font-family: 'Brandon Text';\n    font-display: auto;\n    font-weight: 700;\n    font-style: normal;\n    src: url(", "/fonts/BrandonText-Bold.woff2);\n  }\n"])), Font_config_1.default.cdnBaseUrl[environment], Font_config_1.default.cdnBaseUrl[environment], Font_config_1.default.cdnBaseUrl[environment], Font_config_1.default.cdnBaseUrl[environment]);
};

exports.default = Font;
var templateObject_1;